import { TextField } from '@mui/material';
import { styled } from '@mui/system';
import { red } from '@mui/material/colors';

export const CssTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: red[400]
    },
    '&:hover fieldset': {
      borderColor: red[600]
    },
    '&.Mui-focused fieldset': {
      borderColor: red[700]
    },
    '& label.Mui-focused': {
      color: red[700]
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: red[700]
    }
  }
}));
